export const countryCodeMap: { [key: string]: string } = {
    FR: 'France',
    DE: 'Germany',
};
